var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/relative-timestamp.tsx";
const _excluded = ["timestamp", "intl", "year", "futureDate", "theme"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/web.dom-collections.iterator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import Text from './ui/text/text';
const messages = defineMessages({
  just_now: {
    "id": "relative_time.just_now",
    "defaultMessage": "now"
  },
  seconds: {
    "id": "relative_time.seconds",
    "defaultMessage": "{number}s"
  },
  minutes: {
    "id": "relative_time.minutes",
    "defaultMessage": "{number}m"
  },
  hours: {
    "id": "relative_time.hours",
    "defaultMessage": "{number}h"
  },
  days: {
    "id": "relative_time.days",
    "defaultMessage": "{number}d"
  },
  moments_remaining: {
    "id": "time_remaining.moments",
    "defaultMessage": "Moments remaining"
  },
  seconds_remaining: {
    "id": "time_remaining.seconds",
    "defaultMessage": "{number, plural, one {# second} other {# seconds}} left"
  },
  minutes_remaining: {
    "id": "time_remaining.minutes",
    "defaultMessage": "{number, plural, one {# minute} other {# minutes}} left"
  },
  hours_remaining: {
    "id": "time_remaining.hours",
    "defaultMessage": "{number, plural, one {# hour} other {# hours}} left"
  },
  days_remaining: {
    "id": "time_remaining.days",
    "defaultMessage": "{number, plural, one {# day} other {# days}} left"
  }
});
const dateFormatOptions = {
  hour12: true,
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: 'numeric',
  minute: '2-digit'
};
const shortDateFormatOptions = {
  month: 'short',
  day: 'numeric'
};
const SECOND = 1000;
const MINUTE = 1000 * 60;
const HOUR = 1000 * 60 * 60;
const DAY = 1000 * 60 * 60 * 24;
const MAX_DELAY = 2147483647;

const selectUnits = delta => {
  const absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  } else if (absDelta < HOUR) {
    return 'minute';
  } else if (absDelta < DAY) {
    return 'hour';
  }

  return 'day';
};

const getUnitDelay = units => {
  switch (units) {
    case 'second':
      return SECOND;

    case 'minute':
      return MINUTE;

    case 'hour':
      return HOUR;

    case 'day':
      return DAY;

    default:
      return MAX_DELAY;
  }
};

export const timeAgoString = (intl, date, now, year) => {
  const delta = now - date.getTime();
  let relativeTime;

  if (delta < 10 * SECOND) {
    relativeTime = intl.formatMessage(messages.just_now);
  } else if (delta < 7 * DAY) {
    if (delta < MINUTE) {
      relativeTime = intl.formatMessage(messages.seconds, {
        number: Math.floor(delta / SECOND)
      });
    } else if (delta < HOUR) {
      relativeTime = intl.formatMessage(messages.minutes, {
        number: Math.floor(delta / MINUTE)
      });
    } else if (delta < DAY) {
      relativeTime = intl.formatMessage(messages.hours, {
        number: Math.floor(delta / HOUR)
      });
    } else {
      relativeTime = intl.formatMessage(messages.days, {
        number: Math.floor(delta / DAY)
      });
    }
  } else if (date.getFullYear() === year) {
    relativeTime = intl.formatDate(date, shortDateFormatOptions);
  } else {
    relativeTime = intl.formatDate(date, _objectSpread(_objectSpread({}, shortDateFormatOptions), {}, {
      year: 'numeric'
    }));
  }

  return relativeTime;
};

const timeRemainingString = (intl, date, now) => {
  const delta = date.getTime() - now;
  let relativeTime;

  if (delta < 10 * SECOND) {
    relativeTime = intl.formatMessage(messages.moments_remaining);
  } else if (delta < MINUTE) {
    relativeTime = intl.formatMessage(messages.seconds_remaining, {
      number: Math.floor(delta / SECOND)
    });
  } else if (delta < HOUR) {
    relativeTime = intl.formatMessage(messages.minutes_remaining, {
      number: Math.floor(delta / MINUTE)
    });
  } else if (delta < DAY) {
    relativeTime = intl.formatMessage(messages.hours_remaining, {
      number: Math.floor(delta / HOUR)
    });
  } else {
    relativeTime = intl.formatMessage(messages.days_remaining, {
      number: Math.floor(delta / DAY)
    });
  }

  return relativeTime;
};

/** Displays a timestamp compared to the current time, eg "1m" for one minute ago. */
class RelativeTimestamp extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "_timer", void 0);

    _defineProperty(this, "state", {
      now: Date.now()
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    // As of right now the locale doesn't change without a new page load,
    // but we might as well check in case that ever changes.
    return this.props.timestamp !== nextProps.timestamp || this.props.intl.locale !== nextProps.intl.locale || this.state.now !== nextState.now;
  }

  UNSAFE_componentWillReceiveProps(prevProps) {
    if (this.props.timestamp !== prevProps.timestamp) {
      this.setState({
        now: Date.now()
      });
    }
  }

  componentDidMount() {
    this._scheduleNextUpdate();
  }

  UNSAFE_componentWillUpdate() {
    this._scheduleNextUpdate();
  }

  componentWillUnmount() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
  }

  _scheduleNextUpdate() {
    if (this._timer) {
      clearTimeout(this._timer);
    }

    const {
      timestamp
    } = this.props;
    const delta = new Date(timestamp).getTime() - this.state.now;
    const unitDelay = getUnitDelay(selectUnits(delta));
    const unitRemainder = Math.abs(delta % unitDelay);
    const updateInterval = 1000 * 10;
    const delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
    this._timer = setTimeout(() => {
      this.setState({
        now: Date.now()
      });
    }, delay);
  }

  render() {
    const _this$props = this.props,
          {
      timestamp,
      intl,
      year,
      futureDate,
      theme
    } = _this$props,
          textProps = _objectWithoutProperties(_this$props, _excluded);

    const date = new Date(timestamp);
    const relativeTime = futureDate ? timeRemainingString(intl, date, this.state.now) : timeAgoString(intl, date, this.state.now, year);
    return /*#__PURE__*/React.createElement(Text, _extends({}, textProps, {
      theme: theme,
      tag: "time",
      title: intl.formatDate(date, dateFormatOptions),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 192,
        columnNumber: 7
      }
    }), relativeTime);
  }

}

_defineProperty(RelativeTimestamp, "defaultProps", {
  year: new Date().getFullYear(),
  theme: 'inherit'
});

export default injectIntl(RelativeTimestamp);